"use strict";
/**
 * Defines the roles of the user accounts on PFM.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PfmRole = void 0;
var PfmRole;
(function (PfmRole) {
    /**
     * Standard PFM user or a customer.
     */
    PfmRole["User"] = "user";
    /**
     * The analyst has ability to see all the data on PFM Admin panel.
     */
    PfmRole["Analyst"] = "analyst";
    /**
     * Administrator can manage the entire platform through admin portal.
     */
    PfmRole["Administrator"] = "administrator";
})(PfmRole || (exports.PfmRole = PfmRole = {}));
